<div class="clearfix">
  <nz-pagination [nzPageIndex]="1" [nzTotal]="50"></nz-pagination>
</div>